import {format} from 'date-fns'
import moment from 'moment'

export const CALENDAR_VIEWS = {
  dayGridMonth: {buttonText: 'month'},
  dayGridWeek: {
    buttonText: 'week',
    dayHeaderFormat: {weekday: 'short' as const, day: 'numeric' as const},
  },
}

// Store filter options
export const STORE_FILTER_OPTIONS = [
  {label: 'Midwestgoods', value: 'Midwestgoods'},
  {label: 'CBD To Store', value: 'CBD To Store'},
]

// Calendar navigation utilities
const updateCalendarView = (
  calendarApi: any,
  setViewDateRange: any,
  setIsCurrentDateIsInView: any,
  updateCalendarMonth: any
) => {
  setViewDateRange(calendarApi.currentData.viewTitle)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const {dateProfile} = calendarApi.currentData
  const viewStart = dateProfile?.activeRange?.start ? new Date(dateProfile.activeRange.start) : null
  const viewEnd = dateProfile?.activeRange?.end ? new Date(dateProfile.activeRange.end) : null
  const isTodayInView = viewStart && viewEnd ? today >= viewStart && today < viewEnd : false
  setIsCurrentDateIsInView(isTodayInView)

  // Get the current date from the calendar to determine the month being displayed
  const currentDate = calendarApi.getDate()
  const currentMonth = new Date(currentDate)

  // Calculate the first day of the current month
  const monthStart = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1)

  // Calculate the last day of the current month
  const monthEnd = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0)

  const startDate = format(monthStart, 'yyyy-MM-dd')
  const endDate = format(monthEnd, 'yyyy-MM-dd')

  updateCalendarMonth({
    start: startDate,
    end: endDate,
  })
}

export const handleCalendarMonthChange = (
  action: 'prev' | 'next' | 'today',
  calendarRef: any,
  setViewDateRange: any,
  setIsCurrentDateIsInView: any,
  updateCalendarMonth: any
) => {
  if (calendarRef.current) {
    const calendarApi = calendarRef.current.getApi()
    if (action === 'prev') {
      calendarApi.prev()
    } else if (action === 'next') {
      calendarApi.next()
    } else if (action === 'today') {
      calendarApi.today()
    }
    updateCalendarView(calendarApi, setViewDateRange, setIsCurrentDateIsInView, updateCalendarMonth)
  }
}

// View change handler
export const handleCalendarViewChange = (
  view: 'dayGridMonth' | 'dayGridWeek',
  calendarRef: any,
  setCurrentCalendarView: any
) => {
  if (calendarRef.current) {
    const calendarApi = calendarRef.current.getApi()
    calendarApi.changeView(view)
    setCurrentCalendarView(view)
  }
}

export const handleDayCellDidMount = (info: any, calendarEvents: any) => {
  const {el: cell, date} = info

  // Format date to match API response format (YYYY-MM-DD) using moment to handle timezone
  const dateStr = moment(date).format('YYYY-MM-DD')

  // Check if calendarEvents is available and not empty
  if (!calendarEvents || calendarEvents.length === 0) {
    // Remove has-events class when no events are available
    cell.classList.remove('has-events')
  } else {
    // Check if this date has events by comparing with calendarEvents
    const hasEvents = calendarEvents.some((event: any) => {
      // Compare the date string with event date
      return event.date === dateStr
    })

    // Add or remove has-events class based on data
    if (hasEvents) {
      cell.classList.add('has-events')
    } else {
      cell.classList.remove('has-events')
    }
  }
}

export function toLabelValue(arr: any) {
  return arr.map((item: any) => ({
    label: item,
    value: item
  }));
}

export function makeSemicolonSerratedValues(input: any) {
  if (input?.length && Array.isArray(input)) {
    return input?.join(';')
  } else {
    return ''
  }
}

export function formatDate(dateStr: string) {
  const [year, month, day] = dateStr.split("-").map(Number);

  // month is 1-based in our string, adjust it for JS Date (0-based)
  return format(new Date(year, month - 1, day), "dd MMM yyyy");
}